import { Component, OnInit, ViewContainerRef, HostListener, ElementRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { Location } from '@angular/common';
import * as _ from 'underscore';
import { SharedData } from '../shared/sharedData';
import { TranslateService } from '@ngx-translate/core';
import { Auth } from '../shared/services/auth';

@Component({
    selector: 'switch-user',
    templateUrl: './switchUser.html'
})

export class SwitchUserComponent implements OnInit {
    public _baseUrl: any;
    public isHavingEmpCodes: boolean = true;
    public empArea;
    public showLoading: any = false;
    public switchableUsers: any = [];
    public switchableUsersCount: number = 0;
    public employeeDetails: any = {};
    public employeeId: any;
    public switchPage: any = 'selectSwitchableUsers';
    public selectedAllSwitchAble: any;
    public employeeIdStrList: any = [];
    public totalCount: any;
    public page = 1;
    public startCount = 0;
    public endCount = 10;
    public pageSize = 10;
    trackHides: any;

    ngOnInit() {

    }

    showSearchFilter(event) {
        let searchData = event;
        this.clicked();
        this.searchInSwitchableUsers(searchData);
    }

    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _toaster: ToasterComponent,
        public vcr: ViewContainerRef,
        public _auth: Auth,
        public eRef: ElementRef,
        public _location: Location,
        public _translate:TranslateService,
        public _shareData: SharedData
    ) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        let data: any = this._shareData.getData();
        if (_.isEmpty(data)) {
            this._location.back();
        } else {
            if (data.employee == undefined) {
                this._location.back();
            } else {
                this.employeeDetails = data.employee;
                this.employeeId = this.employeeDetails.id;
                this.getEverySwitchableUsersData();
            }

        }
    }
    everyOneIn() {
        this.empArea = 3;
    }
    everyone() {
        this.empArea = null;
    }
    getEveryEmployee(isEmpCodeAvailable) {
        this.isHavingEmpCodes = isEmpCodeAvailable;
    }

    onPageChange(event){
        this.page = event;
        this.selectedAllSwitchAble = false;
        if(event == 1){
            this.startCount = 0;
            this.endCount = this.pageSize;
            if(this.endCount > this.totalCount){
                this.endCount = this.totalCount;
            }
           
        }
        if(event > 1){
            this.startCount = this.pageSize * (event - 1);
            this.endCount = this.startCount +this.pageSize;
            if(this.endCount > this.totalCount){
                this.endCount = this.totalCount;
            }
           
        }
        this.getEverySwitchableUsersData();
    }


    getEverySwitchableUsersData() {
        let self = this;
        self.switchableUsers = [];
        self.employeeIdStrList = [];
        self.switchableUsersCount = 0;
        // self.totalCount = 0;
        if (this.employeeId) {
            let url = self._baseUrl + "v1/webAdmin/switchEmpAccess/employeeId/" + this.employeeId
                + '?page=' + this.page + '&pageSize=' + 10;
            self.http.get(url).subscribe((result) => {
                if (result.dataList != null) {
                    self.switchableUsers = result.dataList;
                    self.switchableUsersCount = self.switchableUsers.length;
                }
                if (result.totalCount != null) {
                    self.totalCount = result.totalCount;
                }
                self.prepareDataForCheck(self.switchableUsers);
                self.showLoading = true;
            }, (error) => {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    }

    prepareDataForCheck(switchableUsers) {
        _.each(switchableUsers, function (user) {
            user['isChecked'] = false
        });
    }

    selectAll() {
        let self = this;
        self.employeeIdStrList = [];
        _.each(self.switchableUsers, function (user) {
            user.isChecked = !self.selectedAllSwitchAble;
            if (user.isChecked) {
                self.employeeIdStrList.push(user.employeeId);
            }
        });
    }


    unSelect(event, user) {
        user.isChecked = event.target.checked;
        this.getSelectedEmpCodes();
        this.selectedAllSwitchAble = this.switchableUsers.every(function (item: any) {
            return item.isChecked == true;
        });
    }

    getSelectedEmpCodes() {
        let self = this;
        self.employeeIdStrList = [];
        _.each(self.switchableUsers, function (user) {
            if (user.isChecked) {
                self.employeeIdStrList.push(user.employeeId);
            }
        });
    }

    searchInSwitchableUsers(searchData) {
        let self = this;
        if (this.employeeId) {
            let url = self._baseUrl + "v1/webAdmin/switchEmpAccess/searchEmployees/employeeId/" + this.employeeId;
            self.http.post(url, searchData).subscribe((result) => {
                if (result.dataList != null) {
                    self.switchableUsers = result.dataList;
                    self.switchableUsersCount = self.switchableUsers.length;
                }
                if (result.totalCount != null) {
                    self.totalCount = result.totalCount;
                }
                self.prepareDataForCheck(self.switchableUsers);
            }, (error) => {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    }

    getSingleEmployeeData() {
        let self = this;
        self.showLoading = true;
        let url = self._baseUrl + "v1/switch/view";
        self.http.post(url, {}).subscribe((result) => {
            self.switchableUsers = result.content;
            self.showLoading = false;
        }, (error) => {
            console.log("getAllEmployeeData error catch", error);
        });
    }
    changeEmployeeData() {
        let self = this;
        self.showLoading = true;
        let url = self._baseUrl + "v1/switch/change";
        self.http.post(url, {}).subscribe((result) => {
            self.switchableUsers = result.content;
            self.showLoading = false;
        }, (error) => {
            console.log("getAllEmployeeData error catch", error);
        });
    }

    switchToAddSwitchableUsers() {
        // this.switchPage = 'getSwitchableUsers';
        this._shareData.saveData({ employee: this.employeeDetails, type: 'SWITCH' });
        this.router.navigate(['menu/addSwitchableUser']);
    }

    removeSelectedEmpPermission() {
        let self = this;
        if (self.employeeId) {
            let url = self._baseUrl + "v1/webAdmin/switchEmpAccess/deleteMultiple/employeeId/" + self.employeeId;
            self.http.post(url, self.employeeIdStrList).subscribe((result) => {
                console.log('removeSelectedEmpPermission', result);
                self.selectedAllSwitchAble = false;
                self._translate.get('removedPermission').subscribe((msg)=>{
                    self._toaster.showSuccess(msg);
                });
                
                self.getEverySwitchableUsersData();
            }, (error) => {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    }

    removeAllEmpPermission() {
        let self = this;
        if (self.employeeId) {
            let url = self._baseUrl + "v1/webAdmin/switchEmpAccess/deleteAll/employeeId/" + this.employeeId;
            self.http.delete(url).subscribe((result) => {
                self._translate.get('removedPermission').subscribe((msg)=>{
                    self._toaster.showSuccess(msg);
                });
                setTimeout(() => { this._location.back() }, 300);
            }, (error) => {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    }

    // Patch for pop-over issue
  @HostListener('window:click', ['$event'])
  public clickOut(event) {
      if (!this.eRef.nativeElement.contains(event.target)) {
          setTimeout(() => {
              this.trackHides = null;
          }, 10);
      }
  }

  public clicked() {
   this.trackHides = null;
  }

  public closeEmployeeFilter(){
      this._auth.closeFilter();
  }

}



// WEBPACK FOOTER //
// ./src/app/switchUser/switchUser.ts